/* Shto product buy (sections/shto-product-buy.liquid): plan choice, quantity, photos, rating scroll. Runs once per section. */
(function () {
  if (window.shtoProductBuyJS) return;
  window.shtoProductBuyJS = true;
  // Smooth scroll for the rating pill (to the reviews), landing below the theme's fixed header.
  function headerBottom() {
    var h = document.getElementById('header') || document.querySelector('header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'fixed' && pos !== 'sticky') return 0;
    return Math.max(0, h.getBoundingClientRect().bottom);
  }
  if (!window.shtoPBScroll) {
    window.shtoPBScroll = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-shto-pb-scroll]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;
      var target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Going down the theme hides its header, so the reviews land at the top; going up they land under the header.
      var distance = target.getBoundingClientRect().top;
      window.scrollTo({ top: Math.max(0, distance + window.pageYOffset - (distance < 0 ? headerBottom() : 0)), behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function init(root) {
    if (root.shtoPB) return;
    root.shtoPB = true;
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var data = { plans: {} };
    try { data = JSON.parse(q('[data-shto-pb-data]').textContent); } catch (e) {}

    // One-time / Subscribe: like the theme's change_product_subscription_option, the plan dropdown only carries
    // name="selling_plan" while Subscribe is chosen.
    var planSelect = q('[data-shto-pb-plan]');
    var modes = qa('[data-shto-pb-mode]');
    function setMode(mode) {
      modes.forEach(function (input) { input.checked = input.value === mode; });
      qa('[data-shto-pb-card]').forEach(function (card) { card.setAttribute('data-selected', card.getAttribute('data-shto-pb-card') === mode ? 'true' : 'false'); });
      if (planSelect) {
        if (mode === 'subscribe') planSelect.setAttribute('name', 'selling_plan');
        else planSelect.removeAttribute('name');
      }
    }
    modes.forEach(function (input) { input.addEventListener('change', function () { if (input.checked) setMode(input.value); }); });
    if (planSelect) {
      planSelect.addEventListener('change', function () {
        var price = data.plans && data.plans[planSelect.value];
        var el = q('[data-shto-pb-sub-price]');
        if (price && el) el.textContent = price;
        setMode('subscribe');
      });
      planSelect.addEventListener('focus', function () { setMode('subscribe'); });
    }
    var checked = modes.filter(function (m) { return m.checked; })[0];
    setMode(checked ? checked.value : 'onetime');

    // Quantity, 1 to 100 like the theme's field.
    var qty = q('[data-shto-pb-qty-input]');
    function setQty(n) {
      n = parseInt(n, 10);
      if (isNaN(n)) n = 1;
      qty.value = Math.min(100, Math.max(1, n));
    }
    qa('[data-shto-pb-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) + Number(btn.getAttribute('data-shto-pb-qty'))); });
    });
    if (qty) qty.addEventListener('change', function () { setQty(qty.value); });

    // Photos: thumbnails move the main photo; swiping the photo marks its thumbnail.
    var track = q('[data-shto-pb-track]');
    var slides = qa('[data-shto-pb-slide]');
    var thumbs = qa('[data-shto-pb-thumb]');
    var row = q('[data-shto-pb-thumbs]');
    var current = 0;
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, j) { if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      var t = thumbs[i];
      if (row && t && row.scrollWidth > row.clientWidth + 1) {
        var left = t.offsetLeft - thumbs[0].offsetLeft, right = left + t.offsetWidth;
        if (left < row.scrollLeft) row.scrollTo({ left: left, behavior: 'smooth' });
        else if (right > row.scrollLeft + row.clientWidth) row.scrollTo({ left: right - row.clientWidth, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (!track || !slides[i]) return;
        mark(i);
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
    });
    if (track) {
      track.addEventListener('scroll', function () {
        if (!slides.length) return;
        var w = slides[0].offsetWidth || 1;
        var i = Math.min(slides.length - 1, Math.round(track.scrollLeft / w));
        if (i !== current) mark(i);
      }, { passive: true });
    }
  }
  function initAll() { document.querySelectorAll('[data-shto-pb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

